import { render, staticRenderFns } from "./businessHoursForm.vue?vue&type=template&id=ff6ed83c&scoped=true&"
import script from "./businessHoursForm.vue?vue&type=script&lang=js&"
export * from "./businessHoursForm.vue?vue&type=script&lang=js&"
import style0 from "./businessHoursForm.vue?vue&type=style&index=0&id=ff6ed83c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6ed83c",
  null
  
)

export default component.exports